/**
 * SWITCH-GUARD-1 — the only UI map from a surface to a GET /features key.
 * A key that is absent or still loading is off.
 *
 * `teams` and `org-command-center` are seeded OFF by backend #1211. Until that
 * list is in GET /features, a missing key is off, so Teams and /org-dashboard
 * stay hidden.
 */
export const ADMIN_NAV_SWITCH: Record<string, string> = {
  'governance-policies': 'governance-rule-engine',
  'governance-exceptions': 'governance-rule-engine',
  'import-export': 'admin-import-export',
  integrations: 'admin-integrations',
  billing: 'admin-billing',
  capacity: 'resources',
  heatmap: 'resources',
  teams: 'teams',
};

export const PROJECT_TAB_SWITCH: Record<string, string> = {
  resources: 'projects.resources',
  kpis: 'projects.kpis',
  calendar: 'projects.calendar',
  'change-requests': 'projects.change-requests',
};
